import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { EngineerSettingsDto } from "../models/settings/engineer-settings";
import { NotificationService } from "../../core/services/notification.service";
import { Injectable } from "@angular/core";

@Injectable()
export class SettingsService extends DataService<EngineerSettingsDto, EngineerSettingsDto> {
    
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'settings';
    }

    getEngineerSettings() {
        return this.getQuery<EngineerSettingsDto>(`${this.baseUrl()}/engineer`);
    }
}